import { D as DialogBackdrop, a as DialogCloseButton, b as DialogContent, c as DialogDescription, d as DialogPositioner, e as DialogRoot, f as DialogTitle, g as DialogTrigger } from './Dialog-12s-caiSzxm3.js';
export { u as useDialogContext } from './Dialog-12s-caiSzxm3.js';

var Dialog_namespace = {
  __proto__: null,
  Backdrop: DialogBackdrop,
  CloseButton: DialogCloseButton,
  Content: DialogContent,
  Description: DialogDescription,
  Positioner: DialogPositioner,
  Root: DialogRoot,
  Title: DialogTitle,
  Trigger: DialogTrigger
};

export { Dialog_namespace as Dialog, DialogBackdrop, DialogCloseButton, DialogContent, DialogDescription, DialogPositioner, DialogRoot, DialogTitle, DialogTrigger };
